import script from "./LinkEntry.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkEntry.vue?vue&type=script&lang=ts&setup=true"

import "./LinkEntry.vue?vue&type=style&index=0&id=885f673c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-885f673c"]])

export default __exports__